import apiInstance from "./instance";

export interface TTelegramAuthOn {
  payload: {
    password: string;
  };
}

export function telegramAuthOn(apiPayload: TTelegramAuthOn): Promise<any> {
  return new Promise((resolve, reject) => {
    const params = {
      password: apiPayload.payload.password,
    };
    apiInstance
      .post(`auth/admin-telegram-auth-on`, params)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}

export interface TTelegramResendOtpAuthOn {
  payload: {
    user_id: string;
  };
}

export function telegramResendOtpAuthOn(apiPayload: TTelegramResendOtpAuthOn): Promise<any> {
  return new Promise((resolve, reject) => {
    apiInstance
      .get(`auth/admin-telegram-resend-otp/${apiPayload.payload.user_id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}

export interface TTelegramAuthVerify {
  otp_type: "LOGIN" | "AUTH_DISABLE";
  payload: {
    otp: string;
    admin_id: string;
  };
}

export function telegramAuthVerify(apiPayload: TTelegramAuthVerify): Promise<any> {
  return new Promise((resolve, reject) => {
    const params = {
      ...apiPayload.payload,
      otp_type: apiPayload.otp_type,
      ip_address: "59.152.54.146",
    };
    apiInstance
      .post(`auth/admin-telegram-verify-otp`, params)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}

export function telegramAuthOff(): Promise<any> {
  return new Promise((resolve, reject) => {
    apiInstance
      .get(`auth/admin-telegram-auth-off`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}


export function gAuthQROn(): Promise<any> {
  return new Promise((resolve, reject) => {
    apiInstance
      .get(`auth/admin-generate-barcode`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}

export function gAuthVerify({ token }: { token: string }): Promise<any> {
  return new Promise((resolve, reject) => {
    apiInstance
      .post(`auth/admin-verify-otp`, { token })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}

export function gAuthVerifyLoginToken({ token, user_id }: { token: string; user_id: string }): Promise<any> {
  return new Promise((resolve, reject) => {
    apiInstance
      .post(`auth/admin-verify-two-factor-auth`, { token, user_id })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}


export function gAuthOffVerify({ token }: { token: string }): Promise<any> {
  return new Promise((resolve, reject) => {
    apiInstance
      .post(`auth/admin-two-factor-auth-off`, { token })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error?.response ?? error);
      });
  });
}